import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { LoginStatusResponse } from '@core/login-status/models/login-status-response.interface';

@Injectable({
  providedIn: 'root',
})
export class LoginStatusService {
  private readonly httpClient = inject(HttpClient);

  getLoginStatus(): Observable<LoginStatusResponse> {
    const url = 'api/v1/login/status';

    return this.httpClient.get<LoginStatusResponse>(environment.portalApiUrl + url);
  }
}
